import React from "react";
import { Card, CardHeader, CardContent, Typography, Divider } from "@mui/material";
import { db } from "../config/firebase";
import { usePlayerMatch } from "../hooks/usePlayerMatch";
import BasicTable from "./BasicTable";
import { Round, ROUND_STATUS, RoundSolve, updateCurrentRound, updatePlayerRoundSolve, updatePlayerRoundSolveStatus } from "./utils/MatchUtils";

export interface MatchAdminPlayerProps {
  matchId: string,
  playerId: string,
  rounds: Round[],
  roundNumber: number,
  solveNumber: number
}

const MatchAdminPlayer: React.FC<MatchAdminPlayerProps> = ({ matchId, playerId, rounds, roundNumber, solveNumber }) => {
  const { player, roundSolves, loading, error } = usePlayerMatch(db, matchId, playerId);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!player) return <p>Player not found.</p>;

  // Group solves by round number and sort them
  const groupedSolves = roundSolves.reduce((acc: Record<number, RoundSolve[]>, solve) => {
    if (!acc[solve.roundNumber]) acc[solve.roundNumber] = [];
    acc[solve.roundNumber].push(solve);
    return acc;
  }, {});

  // Sort each round's solves by solveNumber
  for (const round in groupedSolves) {
    groupedSolves[round].sort((a, b) => a.solveNumber - b.solveNumber);
  }

  return (
    <Card>
      <CardHeader title={player.displayName} subheader={player.email} />
      <CardContent>
        <BasicTable
          solveResults={roundSolves}
          rounds={rounds}
          roundNumber={roundNumber}
          solveNumber={solveNumber}
          updateStatus={(roundNumber, solveNumber, scramble, time,  status) => {
            // switch (status) {
            //   case ROUND_STATUS.Revealed:
                 updatePlayerRoundSolve(matchId, playerId, roundNumber, solveNumber, scramble, time, status)
            //     break;
            //   default:
                //const solve = roundSolves.find((rs) => rs.roundNumber === roundNumber && rs.solveNumber === solveNumber)
                //if (solve !== undefined && scramble === solve.scramble) {
                  //updatePlayerRoundSolveStatus(matchId, playerId, roundNumber, solveNumber, time, status)
               // }
            //}
          }}
        />
      </CardContent>
    </Card>
  );
};

export default MatchAdminPlayer;
